export const adminViewState = {
  Profile: {
    'Preliminary Information': {
      scriptVisible: true,
      done: false
    },
    'Explanation of Wahve': {
      scriptVisible: true,
      done: false
    },
    'Conclusion to the Interview': {
      scriptVisible: true,
      done: false
    },
  },
  Review: {
    'Preliminary Profile' : {
      scriptVisible: true,
      done: false
    },
    Application : {
      scriptVisible: true,
      done: false
    },
    Assessments : {
      scriptVisible: true,
      done: false
    },
  },
  Interview: {
    Introduction: {
      scriptVisible: true,
      done: false
    },
    'Preferences Availability': {
      scriptVisible: true,
      done: false
    },
    'Work Objectives': {
      scriptVisible: true,
      done: false
    },
    'Home Office Setup': {
      scriptVisible: true,
      done: false
    },
    'Work Experience': {
      scriptVisible: true,
      done: false
    },
    'Employment Gaps': {
      scriptVisible: false,
      done: false
    },
    Skills : {
      scriptVisible: true,
      done: false
    },
    Assessments: {
      scriptVisible: true,
      done: false
    },
    Licenses: {
      scriptVisible: true,
      done: false
    },
    'Professional Designations': {
      scriptVisible: true,
      done: false
    },
    'Professional Associations': {
      scriptVisible: false,
      done: false
    },
    'Behavioral Interview': {
      scriptVisible: true,
      done: false
    },
    'Medicare and Social Security': {
      scriptVisible: true,
      done: false
    },
    'Determination of Status': {
      scriptVisible: true,
      done: false
    },
    Ratings: {
      scriptVisible: true,
      done: false
    }
  }
};



// WEBPACK FOOTER //
// ./shared/react/r_ExpandedCard/adminViewState.js